import { useLocation } from '@reach/router';

import { addSearchQueryToUrl, getPartialSearchQuery } from '~/src/common/navigation';
import { PLAYLIST_QUERY_STRING_KEY } from '~/src/common/playlist';

import { addToUrlConvertedContentFrom } from './addToUrlConvertedContentFrom';

const getCurrentPageAsReturnUrl = (location: Location) => () => {
  const targetUrl = location.pathname;
  const returnUrl = getPageAsReturnUrl(location)(targetUrl);
  return returnUrl;
};

const getPageAsReturnUrl = (location: Location) => (targetUrl: string) => {
  const searchQuery = getPartialSearchQuery({
    search: location.search,
    keyList: [PLAYLIST_QUERY_STRING_KEY],
  });
  const returnUrl = addSearchQueryToUrl(targetUrl, searchQuery);

  return returnUrl;
};

export function useConvertedContentFrom() {
  const location = useLocation();

  return {
    addToUrlConvertedContentFrom: addToUrlConvertedContentFrom(location),
    getCurrentPageAsReturnUrl: getCurrentPageAsReturnUrl(location),
    convertUrlToReturnUrl: getPageAsReturnUrl(location),
  };
}
